import config from './config';
import 'url-search-params-polyfill';
import { fetchQueryParamsFromSession } from './utils';


/* State Diagram of the regexps
* Authored by: Sharique, md.shahab@payu.in
*                                _______________________________________________________________
*                                |                                                             |
* START ---> http ----> s ----> :// ----> any char except . or / ------> . ------> (payumoney.com| payunow.com| payu.in)
* |             |________________|           |                                            |
* |__________________________________________|                                            |
* |                                                                                       |
* |_______________________________________________________________________________________|
*
* */
const payumoneyRegex = /^(https?:\/{2})?([^.\/]+\.)?payumoney\.com/;
const payunowRegex = /^(https?:\/{2})?([^.\/]+\.)?payunow\.com/;
const payuRegex = /^(https?:\/{2})?([^.\/]+\.)?payu\.in/;

class Redirection {

  static setURL(queryParams, fallBackURL) {
    this.fallBackURL = fallBackURL;
    const parsedQueryParams = new URLSearchParams(queryParams);
    const sessionParams = fetchQueryParamsFromSession();
    this.setStaffInviteId(parsedQueryParams);
    const queryRedirectUrls = parsedQueryParams.get('redirectTo') || parsedQueryParams.get('redirect_to');
    const sessionRedirectUrls = sessionParams['redirectTo'] || sessionParams['redirect_to'];
    try {
      /**
       * Check if the urls are valid
       */
      new URL(queryRedirectUrls || sessionRedirectUrls);
      new URL(queryRedirectUrls || sessionRedirectUrls);
      this.redirectToParam = queryRedirectUrls || sessionRedirectUrls;
      this.redirectionURL = queryRedirectUrls || sessionRedirectUrls || this.fallBackURL;
    } catch {
      this.redirectToParam = null;
      this.redirectionURL = this.fallBackURL;
    }
  }

  static getURL() {
    try {
      const redirectionUrl = new URL(this.redirectionURL || this.fallBackURL);
      if (!this.redirectionURL) {
        return this.fallBackURL;
      } else if (this.validateURL(redirectionUrl.hostname)) {
        return this.redirectionURL;
      } else {
        return this.fallBackURL;
      }
    } catch {
      return this.fallBackURL;
    }
  }

  static setStaffInviteId(parsedQueryParams) {
    this.staffInviteId = parsedQueryParams.get('staffInviteId');
  }

  static getStaffInviteId() {
    return this.staffInviteId;
  }

  static validateURL(url) {
    return payumoneyRegex.test(url) || payunowRegex.test(url) || payuRegex.test(url);
  }
}

export default Redirection;
